import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    memberInfo: {
        seq: '',
        nameKor: '',
        memberGbn: '',
    },
};

const memberReducer = createSlice({
    name: 'memberReducer',
    initialState,
    reducers: {
        saveMemberInfo: (state, action) => {
            state.memberInfo.seq = action.payload.seq;
            state.memberInfo.nameKor = action.payload.nameKor;
            state.memberInfo.memberGbn = action.payload.memberGbn;
        },
    },
});

export const { saveMemberInfo } = memberReducer.actions;
export default memberReducer.reducer;
